package er.prateek.crossly.persistence

import com.russhwolf.settings.Settings
import er.prateek.crossly.data.model.math.SavedMathSession
import kotlinx.serialization.json.Json

private val mathSessionJson = Json { ignoreUnknownKeys = true }
private const val KEY_MATH_SESSION = "math_saved_session"
private const val KEY_MATH_NONCE = "math_attempt_nonce"

class SettingsMathSessionStore(
    private val settings: Settings,
) : MathSessionStore {
    override fun load(): SavedMathSession? {
        val raw = settings.getStringOrNull(KEY_MATH_SESSION) ?: return null
        return runCatching { mathSessionJson.decodeFromString(SavedMathSession.serializer(), raw) }.getOrNull()
    }

    override fun save(session: SavedMathSession?) {
        if (session == null) {
            settings.remove(KEY_MATH_SESSION)
        } else {
            settings.putString(KEY_MATH_SESSION, mathSessionJson.encodeToString(SavedMathSession.serializer(), session))
        }
    }

    override fun nextNonce(): Long {
        val next = settings.getLong(KEY_MATH_NONCE, 0L) + 1L
        settings.putLong(KEY_MATH_NONCE, next)
        return next
    }
}
